import AnalysisTeamSearch from "./components/main_page/analysisTeamSearch";
import AnalysisEventSearch from "./components/main_page/analysisEventSearch";
import { Grid, Box, Button, ButtonGroup } from "@mui/material";
import * as React from "react";
import { useEffect, useState, useContext } from "react";
import { ThemeContext } from "../../themes/themes";
import { getSpecificTeam } from "../../api/teams";
import QuickSearch from "../../components/analysis/quickSearch";
import { useNavigate } from "react-router-dom";
import RecentsSearch from "./components/main_page/recentSearches";
import { useGlobal } from "../../context/GlobalProvider";

async function GetSpecificTeam(teamNumber) {
  const data = await getSpecificTeam(teamNumber);
  return data;
}

export default function Analysis({ user, signOut }) {
  const { setCurrentTab } = useGlobal();

  useEffect(() => {
    setCurrentTab("analysis");
  }, []);
  const navigate = useNavigate();
  const [iconPicture, setIconPicture] = useState(null);

  useEffect(() => {
    toggleTheme("analysis");
  }, []);

  useEffect(() => {
    const fetchTeamData = async () => {
      const result = await GetSpecificTeam(user.team_number);
      try {
        const parsedData = JSON.parse(result?.body);
        setIconPicture(
          Array.isArray(parsedData?.data)
            ? parsedData?.data[0]?.icon_picture
            : null
        );
      } catch (error) {
        console.error("Error parsing team data:", error);
        setIconPicture(null);
      }
    };

    fetchTeamData();
  }, [user]);

  const { toggleTheme } = useContext(ThemeContext);

  const [analysisType, setAnalysisType] = useState("recents");

  const handleAnalysisTypeChange = (type) => {
    setAnalysisType(type);
  };

  return (
    <Grid container>
      <Grid
        item
        sm={2}
        sx={{
          display: { xs: "none", sm: "flex" },
          justifyContent: "left",
          alignContent: "top",
          p: 2,
        }}
      >
        <QuickSearch />
      </Grid>
      <Grid item xs={12} sm={8} sx={{ justifyItems: "center" }}>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignContent: "center",
            pt: { xs: 0, sm: 2 },
            px: { xs: 0, sm: 2 },
            pb: 3,
          }}
        >
          <ButtonGroup
            variant="contained"
            sx={{
              width: "100%",
              aspectRatio: "9 / 1",
              minHeight: "70px",
              borderRadius: 4,
            }}
          >
            <Button
              sx={{
                width: "50%",
                color: "#fff",
                opacity: analysisType == "recents" ? 1 : 0.5,
                fontSize: { xs: "4vw", sm: "2.5vw", md: "2vw", lg: "1.5vw" },
                borderRadius: 4,
              }}
              onClick={() => handleAnalysisTypeChange("recents")}
            >
              <b>Recents</b>
            </Button>
            <Button
              sx={{
                width: "50%",
                color: "#fff",
                opacity: analysisType == "teams" ? 1 : 0.5,
                fontSize: { xs: "4vw", sm: "2.5vw", md: "2vw", lg: "1.5vw" },
                borderRadius: 4,
              }}
              onClick={() => handleAnalysisTypeChange("teams")}
            >
              <b>Teams</b>
            </Button>
            <Button
              sx={{
                width: "50%",
                color: "#fff",
                opacity: analysisType == "events" ? 1 : 0.5,
                fontSize: { xs: "4vw", sm: "2.5vw", md: "2vw", lg: "1.5vw" },
                borderRadius: 4,
              }}
              onClick={() => handleAnalysisTypeChange("events")}
            >
              <b>Events</b>
            </Button>
          </ButtonGroup>
        </Box>
      </Grid>
      <Grid
        item
        xs={0}
        sm={2}
        sx={{
          display: { xs: "none", sm: "flex" },
          justifyContent: "right",
          alignItems: "top",
        }}
      >
        <Box
          sx={{
            display: "flex",
            aspectRatio: "1 / 1",
            height: "calc(.4 * 100%)",
            mt: 2,
            mr: 2,
            cursor: "pointer",
          }}
          onClick={() => {
            navigate(`/analysis/team/${user.team_number}`);
          }}
        >
          <img
            src={"data:image/png;base64, " + iconPicture}
            alt={user.team_number + " Icon"}
            style={{
              width: "100%",
              height: "100%",
              borderColor: "#fff",
              borderStyle: "solid",
              borderWidth: 1,
              borderRadius: 5,
            }}
          />
        </Box>
      </Grid>
      {analysisType === "teams" && <AnalysisTeamSearch />}
      {analysisType === "events" && <AnalysisEventSearch />}
      {analysisType === "recents" && <RecentsSearch />}
    </Grid>
  );
}
